import React, { useEffect, useRef, useState } from "react";
import { inject, observer } from "mobx-react";
import Icon from "react-icons-kit";
// import { arrowRight } from "react-icons-kit/fa/arrowRight";
import "../../../assets/css/components/Profile/UpgradeComponent/UpgradeComponent.css";
import ApiCalls from "../../apis/api-calls";
import DetailsTabs from "./DetailsTabs";
import { angleUp } from "react-icons-kit/fa/angleUp";
import { check } from "react-icons-kit/iconic/check";
import { close } from "react-icons-kit/ionicons/close";
import { download3 } from "react-icons-kit/icomoon/download3";
import UpgradeDownloadModal from "./UpgradeDownloadModal";
import { infoCircle } from "react-icons-kit/fa/infoCircle";
import DiagnosticModal from "./DiagnosticModal";
import IssuesTab from "./IssuesTab";

const UpgradeComponent = inject("sharedStore")(
  observer(store => {
    const {
      sharedStore: {
        versionData,
        selectedCurrentVersion,
        currentVersionDate,
        // versionOptions,
        toogleIcon,
        setToogleIcon,
        previousCurrentVersion
        // customVersionOptions
      },
      sharedStore
    } = store;

    const [currentVersionArr, setCurrentVersionArr] = useState([]);
    const [totalVersionArr, setTotalVersionArr] = useState([]);
    const [hotfixArr, setHotfixArr] = useState([]);
    const [versionArr, setVersionArr] = useState([]);
    const [upgradeVersion, setUpgradeVersion] = useState("");
    const [allowedUpgrades, setAllowedUpgrades] = useState([]);
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [fileNames, setFileNames] = useState([]);
    const [releaseNotes, setReleaseNotes] = useState(null);
    const [breakingChanges, setBreakingChanges] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);
    const [tick, setTick] = useState(true);
    const [popup, setPopup] = useState("");
    const node1 = useRef(null);
    const node2 = useRef(null);

    useEffect(() => {
      if (
        versionData &&
        versionData.versionArr &&
        versionData.hotfixArr &&
        versionData.versionArr.length > 0 &&
        versionData.hotfixArr.length > 0
      ) {
        let allVersions = [...versionData.hotfixArr, ...versionData.versionArr];
        let hotfixes = [...versionData.hotfixArr];
        let core = [...versionData.versionArr];
        allVersions.sort(compareVersions);
        hotfixes.sort(compareVersions);
        core.sort(compareVersions);
        setTotalVersionArr(allVersions);
        setHotfixArr(hotfixes);
        setVersionArr(core);
        // setAllowedUpgrades(core);
        if (selectedCurrentVersion !== -1) {
          const filterVal = allVersions.filter(
            val => val.id === Number(selectedCurrentVersion)
          );
          if (filterVal && filterVal.length > 0) {
            const selectedVersion = filterVal[0].value;
            const firstArr = createHotfixes(selectedVersion);
            let secondArr = [...firstArr, core];
            secondArr.sort(compareVersions);
            setCurrentVersionArr(secondArr);
          }
        } else {
          const firstValue = core[core.length - 1];
          const secondValue = createHotfixes(firstValue.value);
          const thirdValue = [firstValue, ...secondValue];
          setAllowedUpgrades(thirdValue);
          setUpgradeVersion(thirdValue[0].value);
          getFiles(1, thirdValue[0].value);
        }
      } else {
        sharedStore.showLoader();
        ApiCalls.fetchVersion()
          .then(res => {
            sharedStore.hideLoader();
            let allVersions = [
              ...res.data.versionData.hotfixArr,
              ...res.data.versionData.versionArr
            ];
            let hotfixes = [...res.data.versionData.hotfixArr];
            let core = [...res.data.versionData.versionArr];
            allVersions.sort(compareVersions);
            hotfixes.sort(compareVersions);
            core.sort(compareVersions);
            setTotalVersionArr(allVersions);
            setHotfixArr(hotfixes);
            setVersionArr(core);
            if (selectedCurrentVersion !== -1) {
              const filterVal = allVersions.filter(
                val => val.id === Number(selectedCurrentVersion)
              );
              if (filterVal && filterVal.length > 0) {
                const selectedVersion = filterVal[0].value;
                const firstArr = createHotfixes(selectedVersion);
                let secondArr = [...firstArr, core];
                secondArr.sort(compareVersions);
                setCurrentVersionArr(secondArr);
              }
            } else {
              const firstValue = core[core.length - 1];
              const secondValue = createHotfixes(firstValue.value);
              const thirdValue = [firstValue, ...secondValue];
              setAllowedUpgrades(thirdValue);
              setUpgradeVersion(thirdValue[0].value);
              getFiles(1, thirdValue[0].value);
            }
          })
          .catch(err => {
            sharedStore.hideLoader();
            console.log("err", err);
          });
      }
    }, []);

    const createRecommendedVersions = version => {
      let checkVersion = version;
      let vals = [];
      if (version.split(".").length === 3) {
        const isACheckpoint = checkpoints.includes(version);
        if (isACheckpoint) {
          const firstArr = checkpoints.map((item, index) => {
            if (item === version) {
              return index;
            } else {
              return null;
            }
          });
          const secondArr = filterArr(firstArr);
          if (secondArr && secondArr.length > 0) {
            checkVersion = checkpointsPlus[secondArr[0]];
            vals = checkpointsPlus[secondArr[0]].split(".");
          } else {
            checkVersion = version;
            vals = version.split(".");
          }
        } else {
          checkVersion = version;
          vals = version.split(".");
        }
        if (version === "v3.0.0") {
          checkVersion = "v3.0.1";
          vals = version.split(".");
        }
      }
      if (version.split(".").length === 4) {
        const splitVals = version.split(".");
        const newVal = `${splitVals[0]}.${splitVals[1]}.${splitVals[2]}`;
        checkVersion = newVal;
        vals = newVal.split(".");
      }
      const firstList = versionArr.map(({ id, value }) => {
        if (value.split(".")[0] === vals[0]) {
          if (Number(value.slice(3)) >= Number(checkVersion.slice(3))) {
            return { id: id, value: value };
          }
          if (value.split(".")[0] < vals[0]) {
            return { id: id, value: value };
          }
          if (value.split(".")[0] > vals[0]) {
            return null;
          }
        }
        if (value.split(".")[0] > vals[0]) {
          if (checkVersion.slice(3) >= "12.0") {
            return { id: id, value: value };
          }
        }
      });
      const secondList = filterArr(firstList).sort(compareVersions);
      let indexes = [];
      for (let i = 0; i < checkpoints.length; i++) {
        for (let j = 0; j < secondList.length; j++) {
          if (secondList[j].value.slice(3) === checkpoints[i].slice(3)) {
            indexes.push(j);
          }
        }
      }
      const finalVersionsList = secondList.slice(indexes[0]);
      return finalVersionsList;
    };

    const createHotfixes = version => {
      const isACheckpoint = checkpoints.includes(version);
      let checkVersion = version;
      if (isACheckpoint) {
        const firstArr = checkpoints.map((item, index) => {
          if (item === version) {
            return index;
          } else {
            return null;
          }
        });
        const secondArr = filterArr(firstArr);
        if (secondArr && secondArr.length > 0) {
          checkVersion = checkpointsPlus[secondArr[0]];
        } else {
          checkVersion = version;
        }
      } else {
        checkVersion = version;
      }
      const firstList = hotfixArr.map(
        ({ id, value, is_private, is_public }) => {
          if (is_private) {
            return {
              id: id,
              value: value,
              is_private: is_private,
              is_public: is_public
            };
          } else {
            if (is_public) {
              const vals = value.split(".");
              const values = checkVersion.split(".");
              if (values.length > 0) {
                if (
                  vals[0] === values[0] &&
                  vals[1] === values[1] &&
                  vals[2] >= values[2]
                ) {
                  return {
                    id: id,
                    value: value,
                    is_private: is_private,
                    is_public: is_public
                  };
                } else {
                  return null;
                }
              } else {
                return null;
              }
            } else {
              return null;
            }
          }
        }
      );
      const finalHotfixList = filterArr(firstList).sort(compareVersions);
      return finalHotfixList;
    };

    const getIndexOfNextCoreVersion = (arr, selectedCurrentVersion) => {
      let firstList = [...arr];
      firstList.sort(compareVersions);
      const secondList = firstList.map(({ id, value }, index) => {
        const vals = value.split(".");
        if (vals.length === 3 && vals[2] === "0") {
          return index;
        } else {
          return null;
        }
      });
      // console.log(secondList);
      const thirdList = filterArr(secondList);
      // console.log(thirdList);
      if (thirdList.length > 0) {
        let index = 0;
        for (let i = 1; i <= thirdList.length; i++) {
          index = thirdList[thirdList.length - i];
          // console.log(index);
          // console.log(arr[index], selectedCurrentVersion);
          // console.log("loop", i);
          if (arr[index].id !== Number(selectedCurrentVersion)) {
            if (index) {
              return index;
            } else {
              return 0;
            }
          } else {
            index = 0;
          }
        }
        // console.log("Returning Index", index);
        return index;
      } else {
        return 0;
      }
    };
    const months = [
      0,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const checkpoints = [
      "v3.0.0",
      "v3.3.0",
      "v3.6.0",
      "v3.9.0",
      "v3.12.0",
      "v4.0.0"
    ];
    const checkpointsPlus = [
      "v3.1.0",
      "v3.3.1",
      "v3.6.1",
      "v3.9.1",
      "v3.12.0",
      "v4.0.0"
    ];
    const formatDate = val => {
      if (val && typeof val === "string") {
        const date = val.split("T")[0];
        const splitDate = date.split("-");
        const finalDate = `${months[Number(splitDate[1])]} ${splitDate[2]} ${
          splitDate[0]
        }`;
        return finalDate;
      } else {
        return `Date Unavailable`;
      }
    };

    const compareVersions = (a, b) => {
      let nums1 = a.value.replace("v", "").split(".");
      let nums2 = b.value.replace("v", "").split(".");
      return (
        nums2.shift() - nums1.shift() ||
        nums2.shift() - nums1.shift() ||
        nums2.shift() - nums1.shift() ||
        nums2.shift() - nums1.shift()
      );
    };

    useEffect(() => {
      const filterVal = totalVersionArr.filter(
        val => val.id === Number(selectedCurrentVersion)
      );
      if (filterVal && filterVal.length > 0) {
        const selectedVersion = filterVal[0].value;
        const firstArr = createRecommendedVersions(selectedVersion);
        const secondArr = createHotfixes(selectedVersion);
        let currentArr = [...secondArr, ...versionArr];
        currentArr.sort(compareVersions);
        setCurrentVersionArr(currentArr);
        let thirdArr = [...secondArr, ...firstArr];
        thirdArr.sort(compareVersions);
        setAllowedUpgrades(thirdArr);
        let index = 0;
        if (selectedVersion.split(".").length === 3) {
          index = getIndexOfNextCoreVersion(thirdArr, selectedCurrentVersion);
        }
        if (selectedVersion.split(".").length === 4) {
          const splitVals = selectedVersion.split(".");
          const newVal = `${splitVals[0]}.${splitVals[1]}.0`;
          const filterValTwo = totalVersionArr.filter(
            val => val.value === newVal
          );
          if (filterValTwo && filterValTwo.length > 0) {
            index = getIndexOfNextCoreVersion(thirdArr, filterValTwo[0].id);
          } else {
            index = 0;
          }
        }
        setUpgradeVersion(thirdArr[index].value);

        if (firstLoad) {
          getFileNames(thirdArr[index].value);
          setFirstLoad(false);
        }
      }
    }, [selectedCurrentVersion, totalVersionArr, setTotalVersionArr]);

    const handleDropdownSelect = e => {
      const { value, name } = e.target;
      if (name === "currentVersion") {
        setTick(false);
        sharedStore.setSelectedCurrentVersion(value);
        setToogleIcon(true);
      } else {
        let filteredVersion = totalVersionArr.filter(
          val => val.value === value
        );
        if (filteredVersion.length > 0 && !toogleIcon) {
          getFileNames(filteredVersion[0].value);
        }
        setUpgradeVersion(value);
      }
    };

    const filterArr = arr => {
      return arr.filter(function(e) {
        return e;
      });
    };

    const getFiles = (type, value) => {
      sharedStore.showLoader();
      if (type === 1) {
        ApiCalls.fetchResources({ version: value })
          .then(res => {
            const files = Object.keys(res.data.Files);
            setFileNames(files.sort());
            sharedStore.hideLoader();
          })
          .catch(err => {
            console.log(err);
            sharedStore.hideLoader();
          });
      }
      if (type === 2) {
        ApiCalls.fetchCustomBuildResources({ version: value })
          .then(res => {
            const files = Object.keys(res.data.Files);
            setFileNames(files.sort());
            sharedStore.hideLoader();
          })
          .catch(err => {
            console.log(err);
            sharedStore.hideLoader();
          });
      }
    };

    const getFileNames = version => {
      const selected = version;
      const length = selected.split(".").length;
      if (length === 3) {
        fetchReleaseNotes(selected);
        getFiles(1, selected);
      }
      if (length === 4) {
        fetchReleaseNotes(selected);
        getFiles(2, selected);
      }
    };

    const triggerDownloadModal = () => {
      setIsDownloadModalOpen(!isDownloadModalOpen);
      if (selectedCurrentVersion === -1) {
        const newArr = totalVersionArr.filter(
          ({ value }) => value === upgradeVersion
        );
        if (newArr && newArr.length > 0) {
          ApiCalls.updateCurrentVersion({ version_id: newArr[0].id });
        }
      }
    };

    const fetchReleaseNotes = version => {
      ApiCalls.releaseNotes(version)
        .then(res => {
          setReleaseNotes(res.data.release_notes);
          setBreakingChanges(res.data.breaking_changes);
        })
        .catch(err => {
          console.error(err);
        });
    };

    const hideIcon = (e, type) => {
      if (type === "check") {
        sharedStore.showLoader();
        setTick(true);
        ApiCalls.updateCurrentVersion({ version_id: selectedCurrentVersion })
          .then(res => {
            sharedStore.hideLoader();
            sharedStore.getCurrentVersion();
          })
          .catch(err => sharedStore.hideLoader());
        getFileNames(upgradeVersion);
      } else {
        sharedStore.setSelectedCurrentVersion(previousCurrentVersion);
      }
      setToogleIcon(false);
    };

    const handleClick = (e, type) => {
      if (type) {
        // attach/remove event handler
        document.addEventListener("click", handleOutsideClick, false);
      } else {
        document.removeEventListener("click", handleOutsideClick, false);
      }
      setPopup(type);
    };

    const handleOutsideClick = e => {
      // ignore clicks on the component itself
      if (node1.current && node1.current.contains(e.target)) {
        return;
      }
      if (node2.current && node2.current.contains(e.target)) {
        return;
      }
      handleClick();
    };

    return (
      <React.Fragment>
        <div className="">
          <div className="wrap-block">
            <div className="upgrade_head_block">
              <div className="head_block_left">Upgrade</div>
              <div className="head_block_right">
                <span className="dwn-ut_txt">
                  <a
                    href="http://izenda.com/docs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Want to deploy Izenda in a new environment?
                  </a>
                </span>
              </div>
            </div>
            <div className="current_version">
              <div className="current_version_left">
                <strong> Your Current Version is:</strong>
                <br />
                <small className="verinfo">
                  {currentVersionDate
                    ? "Last Updated" + " " + formatDate(currentVersionDate)
                    : null}
                </small>
              </div>
              <div className="current_version_right">
                <div className="version-text">
                  {toogleIcon ? (
                    <div className="version-icon">
                      <span
                        className={"tick-mark"}
                        onClick={e => hideIcon(e, "check")}
                      >
                        <Icon size={20} icon={check} />
                      </span>
                      <span
                        className={"cross"}
                        onClick={e => hideIcon(e, "close")}
                      >
                        <Icon size={20} icon={close} />
                      </span>
                    </div>
                  ) : null}

                  <div className="ver_help_txtx upgrade_help_wrapper">
                    <a
                      onClick={e => handleClick(e, 1)}
                      className="infover"
                      ref={node1}
                    >
                      Not Correct?
                      {popup === 1 && (
                        <div className="custom_note_txt">
                          <span className="down_arrow">
                            <Icon size={40} icon={angleUp} />
                          </span>
                          <p className="up_hlp_txt">
                            Update your current version by selecting the correct
                            version in the drop-down menu above.
                          </p>
                          <p className="up_note_txt">
                            Please note: Legacy custom builds are not displayed
                            in this drop-down, however, all custom builds moving
                            forward will be.
                          </p>
                        </div>
                      )}
                    </a>
                  </div>
                  <select
                    id="currVersion"
                    value={selectedCurrentVersion || null}
                    onChange={handleDropdownSelect}
                    name="currentVersion"
                  >
                    {!selectedCurrentVersion ||
                      (selectedCurrentVersion === -1 && (
                        <option key={-1} value={""} />
                      ))}

                    {currentVersionArr.map((version, i) => {
                      return (
                        <option key={i} value={version.id}>
                          {version.value}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="current_version">
              <div className="current_version_left">
                <span className="rec_upgrade">
                  <strong>Recommended Upgrade:</strong>
                </span>
              </div>
              <div className="current_version_right">
                <div className="version-text">
                  {/* <button class="btn btn-common cumstom_upgrade_btn">
                    SCHEMA MIGRATION
                  </button> */}
                  <button
                    className="btn btn-common cumstom_upgrade_btn"
                    onClick={triggerDownloadModal}
                    disabled={toogleIcon}
                  >
                    <Icon size={18} icon={download3} className="downloadIcon" />{" "}
                    Download
                  </button>
                  <select
                    value={upgradeVersion}
                    onChange={handleDropdownSelect}
                    name="coreVersion"
                  >
                    {allowedUpgrades.map((version, i) => {
                      return (
                        <option key={i} value={version.value}>
                          {version.value}
                        </option>
                      );
                    })}
                  </select>
                  <div className="ver_info_text">
                    <a
                      onClick={e => handleClick(e, 2)}
                      className="infover"
                      ref={node2}
                    >
                      <Icon
                        className="info_circle_icons"
                        size={25}
                        icon={infoCircle}
                      />
                      {popup === 2 && (
                        <div className="custom_note_txt">
                          <span className="down_arrow">
                            <Icon size={40} icon={angleUp} />
                          </span>
                          <div className="popup_text">
                            <b>Core & Preview Releases:</b> Due to breaking
                            changes, we are limiting upgrades to make sure
                            testing is done thoroughly in customer environments.
                          </div>
                          <br />
                          <div className="popup_text">
                            <b>Custom Builds:</b> Please download the latest
                            Izenda version in the Preview/Core Release tab in
                            order to access the latest custom build.
                          </div>
                        </div>
                      )}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <DiagnosticModal />
            </div>
            <div className="upgrade_item_wrapper">
              <DetailsTabs
                releaseNotes={releaseNotes}
                breakingChanges={breakingChanges}
              />
            </div>
            {/* <div>
              <IssuesTab />
            </div> */}
            {isDownloadModalOpen && (
              <UpgradeDownloadModal
                triggerDownloadModal={triggerDownloadModal}
                fileNames={fileNames}
                upgradeVersion={upgradeVersion}
                setUpgradeVersion={setUpgradeVersion}
                breakingChanges={breakingChanges}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  })
);

export default UpgradeComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/UpgradeComponent/UpgradeComponent.js